import React, { useState, useEffect, useRef, useContext } from "react";
import {
  ContentWrapper,
  SnackbarContent,
  PageTitle,
  SVGContainer,
  TTBody
} from "../styled-components/shared";
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import { Switch, Button } from "@zebra-fed/zds-react-desktop";
import Snackbar from "@material-ui/core/Snackbar";
import styled from "styled-components";
import firebaseUtil from "../data/FirebaseUtil";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import DropdownCustom from '../components/DropdownCustom';

import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { withStyles } from '@material-ui/core/styles';

import { AuthContext } from "../authentication/Auth";
import app from "../authentication/firebaseStart";
import BottomNavLinks from "../components/BottomNavLinks";
const firestore = app.firestore();


const StyledContentWrapper = styled(ContentWrapper)`
  padding: 10px;
`;

const ButtonContainer = styled.div`
    display: inline;
    max-width: 500px;
    justify-content: initial;
`;

const StyledTextField = styled(TextField)`
  margin-left: 2px !important;
  margin-bottom: 20px !important;
`;


const ErrorMsg = styled.p`
    margin: 0;
    padding-left: 10px;
    font-size: 0.75rem;
    margin-top: 3 px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    color: red;
`;

const StyledOnDiv = styled.div`
  margin-left: 65px;
`;

const QuestionTT = withStyles((theme) => ({
  position: 'absolute',
    bottom: '3px',
    right: '-15px',
  tooltip: {
    backgroundColor: 'rgb(0, 122, 186)',
    color: theme.typography.pxToRem(12),
    maxWidth: 300,
    border: '1px solid rgb(0, 122, 186)',
  },

  arrow: {
    color: 'rgb(0, 122, 186)'
  },
}))(Tooltip);

const CheckboxComp = styled.label`
    display: flex;
    align-items: center;
    margin-left: -10px;
`;


export default function LostDevicePage({setSnackbarOpen, serverResponse}) {
  const DEFAULT_MAXRSSI = -100;
  const context = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation()
  const [enableSwitch, setEnableSwitch] = useState(false);

  const [anyOneChanged, setAnyOneChanged] = useState(false);
  const [error, setError] = React.useState(false);
  //const [helperText, setHelperText] = React.useState('Choose wisely');
  const [isPageLoading, setPageLoading] = useState(false);
  const [disabledAudioCheckbox, setDisabledAudioCheckbox] = useState(true);
  const [disabledVibrateCheckbox, setDisabledVibrateCheckbox] = useState(true);
  const [disabledLedCheckbox, setDisabledLedCheckbox] = useState(true);

  const [lostDevice, setLostDevice] = useState(false);
  const [enableAudio, setEnableAudio] = useState(false);
  const [enableVibrate, setEnableVibrate] = useState(false);
  const [enableLED, setEnableLED] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState(t('lostDeviceNearbyNotifications.defaultNotificationMsg'));
  const [maxRssi, setMaxRssi] = useState(DEFAULT_MAXRSSI);
  const [testAud, setTestAud] = useState("Default");
  const [customAudioToneText, setCustomAudioToneText] = useState("");
  const [vibratePattern, setVibratePattern] = useState([{
    label: t('lostDeviceNearbyNotifications.systemDefault'), 
    value: t('lostDeviceNearbyNotifications.systemDefault')
  }]);
  const [vibratePatternArr, setVibratePatternArr] = useState([
    { label: t('lostDeviceNearbyNotifications.systemDefault'), value: t('lostDeviceNearbyNotifications.systemDefault') },
    { label: t('lostDeviceNearbyNotifications.Short'), value: t('lostDeviceNearbyNotifications.Short') },
    { label: t('lostDeviceNearbyNotifications.Medium'), value: t('lostDeviceNearbyNotifications.Medium') },
    { label: t('lostDeviceNearbyNotifications.Long'), value: t('lostDeviceNearbyNotifications.Long') }
  ]);
const [audioCustom, setaudioCustom] = useState(false)
  /*   const [ledColor, setLedColor] = useState([{}]);
    const [ledColorArr, setLedColorArr] = useState([
      { label: t('lostDeviceNearbyNotifications.System Default'), value: 'Default' },
      { label: t('lostDeviceNearbyNotifications.Blue'), value: t('lostDeviceNearbyNotifications.Blue') },
      { label: t('lostDeviceNearbyNotifications.Red'), value: t('lostDeviceNearbyNotifications.Red') },
      { label: t('lostDeviceNearbyNotifications.Green'), value: t('lostDeviceNearbyNotifications.Green') }
    ]);
   */
  const errors = useRef([]);
  const [checkErrors, setCheckErrors] = useState(false);

  const ButtonStyle = {
    margin: "0",
    display: "flex",
    alignSelf: "flex-end",
    cursor: isLoading ? "wait" : "pointer"
  };

  const onClickCancelBtn = () => {
    setAnyOneChanged(false);
    getSettings();
  }

  useEffect(() => {
    getSettings();
  }, []);

  async function getSettings() {
    let companyID = context.currentUser.claims.companyID;
    let data = (
      await firestore
        .collection("tenants")
        .doc(companyID)
        .collection("Configuration")
        .doc("AppSettings")
        .get()
    ).data();

    if (data) {
      setLostDevice(data.enableLostDeviceNotification);
      setEnableAudio(data?.lostDeviceNotificationSettings?.enableAudio);
      setCustomAudioToneText(data?.lostDeviceNotificationSettings?.audioName)
      setaudioCustom(data?.lostDeviceNotificationSettings?.audioName !== "Default")
      //console.log(audioCustom,'audioCustom')
      setEnableVibrate(data?.lostDeviceNotificationSettings?.enableVibrate);

      //console.log(data?.lostDeviceNotificationSettings?.audioName,'Check if undefined')
      if (data?.lostDeviceNotificationSettings?.audioName === "Default") {
        //console.log(data?.lostDeviceNotificationSettings?.audioName,'Inside data?.lostDeviceNotificationSettings?.audioName If')
        setTestAud(data.lostDeviceNotificationSettings.audioName);
        setCustomAudioToneText("");
      }
      else {
        if(data?.lostDeviceNotificationSettings?.audioName === undefined) {
          //console.log('mdv')
          setTestAud("Default");
          setaudioCustom(false);
          console.log(testAud,'testAud if undefined')
        }
        else {
          //console.log(data.lostDeviceNotificationSettings?.audioName,'data.lostDeviceNotificationSettings?.audioName')
          setTestAud(data.lostDeviceNotificationSettings?.audioName);
          setCustomAudioToneText(data.lostDeviceNotificationSettings?.audioName)
        }
        
      }
      //console.log(data.lostDeviceNotificationSettings.vibratePattern,'data.lostDeviceNotificationSettings.vibratePattern')
      let vibratePat = data?.lostDeviceNotificationSettings?.vibratePattern;
      //console.log(vibratePat, 'vibratePatvibratePatvibratePat')
      if (vibratePat === "Default") {
        setVibratePattern([
          {
            label: t('lostDeviceNearbyNotifications.systemDefault'),
            value: t('lostDeviceNearbyNotifications.systemDefault')
          }
        ]);
      }
      else {
        if(vibratePat === undefined) {
          //console.log(vibratePat,'if vibratePat undefined')
          setVibratePattern([
            {
              label: t('lostDeviceNearbyNotifications.systemDefault'), value: t('lostDeviceNearbyNotifications.systemDefault')
            }
          ]);  
        }
        else {
          setVibratePattern([
            {
              label: vibratePat,
              value: vibratePat
            }
          ]);
        }
        
      }
      //console.log(data.lostDeviceNotificationSettings?.maxRSSI,'data.lostDeviceNotificationSettings?.maxRSSI')
      /* setLedColor([
        {
          label: data.lostDeviceNotificationSettings.ledColor,
          value: data.lostDeviceNotificationSettings.ledColor
        }
      ]); */
      setEnableLED(data.lostDeviceNotificationSettings?.enableLED)
      setNotificationMessage(data.lostDeviceNotificationSettings?.notificationMessage);
      setDisabledAudioCheckbox(data.lostDeviceNotificationSettings?.enableAudio);
      setDisabledVibrateCheckbox(data.lostDeviceNotificationSettings?.enableVibrate);
      setDisabledLedCheckbox(data.lostDeviceNotificationSettings?.enableLED);
      let maxrssi = parseInt(data.lostDeviceNotificationSettings?.maxRSSI);
      //console.log(maxrssi,'maxrssi')
      //console.log(isNaN(maxrssi),'(isNaN(maxrssi)')
      setMaxRssi((isNaN(maxrssi) || maxrssi == 0) ? DEFAULT_MAXRSSI : maxrssi);
    }
  }

  async function handleSaveChanges() {
    errors.current = [];
    //console.log(vibratePattern, 'vibratePattern');
    let vibratePatternStr = vibratePattern[0]?.value;
    if (vibratePatternStr === "System Default") {
      vibratePatternStr = "Default";
    }
    //console.log(vibratePatternStr, 'vibratePatternStr')
    // let ledColorStr = ledColor[0].value;
    let data = {
      enableLostDeviceNotification: lostDevice,
      lostDeviceNotificationSettings: {
        "audioName": testAud,
        "enableAudio": enableAudio,
        "enableVibrate": enableVibrate,
        "enableLED": enableLED,
        // "ledColor": ledColorStr,
        "notificationMessage": notificationMessage,
        "scanPeriod": 10000,
        "scanWaitingPeriod": 20000,
        "maxRSSI": parseInt(maxRssi),
        "vibratePattern": vibratePatternStr,
        "lowBatteryScan": false,
        "clearNotificationTime": 5
      }
    };
    if (testAud === "") {
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("audioToneNameErr");
    }
    if (notificationMessage == "") {
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("notificationMessageErr");
    }
    else if (notificationMessage?.length < 5) {
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("notificationMessageErr");
    }
    //console.log(parseInt(maxRssi),maxRssi,/^-?\d+$/.test(maxRssi))
    if(!maxRssi || maxRssi === null || parseInt(maxRssi) === 0) {
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("maxrssiErr")
    }else if(!/^-?\d+$/.test(maxRssi)){
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("maxrssiAlpaMsg")     
    }else if(!/^-\d+$/.test(maxRssi)){
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("maxrssiNegMsg")     
    }else if(parseInt(maxRssi)>-50){
      setCheckErrors(!checkErrors);
      errors.current = errors.current.concat("maxrssi50Msg")     
    }
    if (errors.current.length === 0) {
      setIsLoading(true);
      let response = await firebaseUtil.saveAppSettings(data);
      setIsLoading(false);
      serverResponse.current = response;
      if (response.status) {
        setAnyOneChanged(false);
      }
      setSnackbarOpen(true);
    }

  }

  const onAudioCheckbox = (audioEvent) => {
    setAnyOneChanged(true);
    setEnableAudio(audioEvent);
    if (audioEvent) {
      setDisabledAudioCheckbox(true);
    }
    else {
      setDisabledAudioCheckbox(false);
    }
  }

  const onAudioTone = (audioToneEvent) => {
    if (audioToneEvent === "Default") {
      setTestAud(audioToneEvent);
      setCustomAudioToneText("");
    }
    else {
      setTestAud(audioToneEvent);
      setCustomAudioToneText(audioToneEvent);
    }
    setAnyOneChanged(true);
  }

  const onCustomAudioToneText = (customToneVal) => {
    setCustomAudioToneText(customToneVal);
    setTestAud(customToneVal);
    setAnyOneChanged(true);
  }

  const onVibrateCheckbox = (vibrateEvent) => {
    setEnableVibrate(vibrateEvent);
    setAnyOneChanged(true);
    if (vibrateEvent) {
      setDisabledVibrateCheckbox(true);
    }
    else {
      setDisabledVibrateCheckbox(false);
    }
  }

  const onLedCheckbox = (ledEvent) => {
    setEnableLED(ledEvent);
    setAnyOneChanged(true);
    if (ledEvent) {
      setDisabledLedCheckbox(true);
    }
    else {
      setDisabledLedCheckbox(false);
    }
  }

  const onClickResetBtn = () => {
    setAnyOneChanged(true);
    setLostDevice(false);
    setEnableAudio(false);
    setEnableVibrate(false);
    setEnableLED(false);
    setNotificationMessage(t('lostDeviceNearbyNotifications.defaultNotificationMsg'));
    setTestAud("Default");
    setCustomAudioToneText('');
    setVibratePattern([{ label: t('lostDeviceNearbyNotifications.systemDefault'), value: t('lostDeviceNearbyNotifications.systemDefault') }]);
    // setLedColor([{ label: "System Default", value: "Default" }]);
    setMaxRssi(DEFAULT_MAXRSSI);
  }

  const onChangeSwitch = (switchEvent) => {
    if (switchEvent === true) {
      setEnableSwitch(true);
      setDisabledLedCheckbox(true);
      setDisabledVibrateCheckbox(true);
    }
    else {
      setEnableSwitch(false);
      setDisabledLedCheckbox(false);
      setDisabledVibrateCheckbox(false);
    }
    setLostDevice(switchEvent);
    if (switchEvent !== lostDevice) {
      setAnyOneChanged(true);
    }
  }

  const onVibratePatternChange = (vibratePatternVal) => {
    setVibratePattern([
      { label: vibratePatternVal, value: vibratePatternVal }
    ]);
    setAnyOneChanged(true);
  }

  /*   const onLedColorChange = (ledColor) => {
      console.log(ledColor, 'led Color value')
      setLedColor([
        { label: ledColor, value: ledColor }
      ]);
      setAnyOneChanged(true);
    } */

  const onPopupMsgChange = (popupMsg) => {
    //console.log(popupMsg, 'sdsds')
    //console.log(popupMsg.length)
    if (popupMsg.length > 65) {
      return;
    }
    // else if(popupMsg.length < 5) {
    //   return;
    // }
    else {
      setNotificationMessage(popupMsg);
      setAnyOneChanged(true);
    }
  }

  const onMaxRssiChange = (maxrssi) => {
    // if(maxrssi == '-'){
    //   maxrssi = NaN
    // }
    //console.log(maxrssi,'maxrssi onchange');

    // maxrssi = parseInt(maxrssi)
    // console.log( Number.isInteger(parseInt(maxrssi)))
    setAnyOneChanged(true);

    setMaxRssi(maxrssi)

    // if(Number.isInteger(parseInt(maxrssi))){
    //   console.log('came')
    //   setMaxRssi(parseInt(maxrssi))}
    // else if(maxrssi == '-' ){
    //   console.log('camew')
      
    //   setMaxRssi('')}
  }

  //console.log(vibratePattern, 'vibratePattern')
  return (
    <>

        <h3>{t('lostDeviceNearbyNotifications.lostDeviceNearbyHeading')}</h3>
        <div
          style={{
            display: isPageLoading ? "flex" : "none",
            justifyContent: "left",
          }}
        >
          <CircularProgress />
        </div>
        <FormControlLabel
          classes="onOffSwitch"
          control={<StyledOnDiv><Switch color="primary" checked={lostDevice} onChange={(e) => onChangeSwitch(e)} /> </StyledOnDiv>}
          label={t('lostDeviceNearbyNotifications.Send lost device nearby notification')}
          labelPlacement="start"
          style={{ marginLeft: 0, fontWeight: 'bold', marginTop: '30px' }}
        />

        <FormGroup style={{ marginLeft: '20px', width: '225px' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={enableAudio}
                onChange={(e) => onAudioCheckbox(e.target.checked)}
                name="audio"

                // value={setEnableAudio}
              />
            }
            label={t('lostDeviceNearbyNotifications.Audio')}
            disabled={enableSwitch ? false : true}
          />

          <FormControl disabled={enableSwitch ? false : true} component="fieldset" style={{ marginLeft: '30px',position:"relative" }}
          >
            <RadioGroup  aria-label="audio_tone" name="audio_tone" value={testAud}
              onChange={(e) => {
                onAudioTone(e.target.value);
                setaudioCustom(!audioCustom);
              }
              }>
              <FormControlLabel value="Default"
                control={
                  <Radio color="primary" disabled={!enableAudio || !enableSwitch}/>
                } label={t('btScannersNotifications.systemDefault')}
              />
              <FormControlLabel value={customAudioToneText}
                control={
                  
                  <Radio onchange={(e)=>{ }} color="primary"  disabled={ !enableAudio || !enableSwitch }/>
                } label={
                  //!enableAudio ||

                  
                  <TextField id="custom_tone_name" disabled={  !enableAudio || !audioCustom || !enableSwitch} name="custom_tone_name" style={{ width: '150px' }}
                    label={t('lostDeviceNearbyNotifications.customToneName')} onChange={(e) => { onCustomAudioToneText(e.target.value); }}
                    value={customAudioToneText} />

                    
                } /> 
            </RadioGroup>
            <div style={    {position: 'absolute',    bottom: '3px',    right: '-15px'}}>
       <QuestionTT  arrow title={<>
              <TTBody>

                {t('lostDeviceNearbyNotifications.customtonetooltip')}

              </TTBody>
            </>}>
              <SVGContainer>
                <HelpOutlineIcon />
              </SVGContainer>
            </QuestionTT>
    </div>
           
            {errors.current.includes("audioToneNameErr") ? (<ErrorMsg>{t('validation.rules.lostDevice.audioToneNameErr')}</ErrorMsg>) : null}

          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => onVibrateCheckbox(e.target.checked)}
                name="vibrate"
                // color="primary"
                checked={enableVibrate}
              />
            }
            label={t('lostDeviceNearbyNotifications.Vibrate')}
            disabled={enableSwitch ? false : true}
          />
          <div className="lost-device-vibrate-pattern">
            <DropdownCustom
              selectVal={vibratePattern}
              selectOpts={vibratePatternArr}
              onChange={(e) => onVibratePatternChange(e.target.value)}
              isDisabled={!enableVibrate || !enableSwitch }
            />
          </div>
          {/* <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => onLedCheckbox(e.target.checked)}
                name="led"
                checked={enableLED}
              />
            }
            label={t('lostDeviceNearbyNotifications.LED')}
            disabled={enableSwitch ? false : true}
          />
          <QuestionTT arrow title={<>
            <TTBody>
              <p>
                {"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."}
              </p>

            </TTBody>
          </>}>
            <SVGContainer>
              <HelpOutlineIcon />
            </SVGContainer>
          </QuestionTT> */}

          <CheckboxComp>
            <Checkbox
              checked={enableLED}
              name="led"
              onChange={(e) => onLedCheckbox(e.target.checked)}
              disabled={enableSwitch ? false : true}
            />
            <Typography >{t('lostDeviceNearbyNotifications.LED')}</Typography>


            <QuestionTT arrow title={<>
              <TTBody>

                {t('lostDeviceNearbyNotifications.DefaultBlueLED')}

              </TTBody>
            </>}>
              <SVGContainer>
                <HelpOutlineIcon />
              </SVGContainer>
            </QuestionTT>
          </CheckboxComp>

          {/*           <div className="lost-device-led-color">

              <DropdownCustom
                selectVal={ledColor}
                selectOpts={ledColorArr}
                onChange={(e) => onLedColorChange(e.target.value)}
                isDisabled={disabledLedCheckbox ? false : true}
              />


          </div> */}

          {/* <FormControlLabel
            control={
              <Checkbox
                checked={true}
                disabled={enableSwitch ? false : true}
                name="Enable Notification message"
              // color="primary"
              />
            }
            label={t('lostDeviceNearbyNotifications.Pop-up Message')}
          /> */}

<p style={{fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
    margin: '0 0 8px 2px'}}>{t('lostDeviceNearbyNotifications.Pop-up Message')}</p>

          <StyledTextField
            placeholder={""}
            disabled={enableSwitch ? false : true}
            name="popupms"
            value={notificationMessage}
            onChange={(e) => onPopupMsgChange(e.target.value)}
          />
          {errors.current.includes("notificationMessageErr") ? (<ErrorMsg>{t('validation.rules.lostDevice.notifyMsgErr')}</ErrorMsg>) : null}

      
            
            <p style={{fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.00938em',
    margin: '0 0 8px 2px'}}>{t('lostDeviceNearbyNotifications.Max RSSI Value')}</p>
    
          <StyledTextField
            id="standard-basic" 
            //label="Max RSSI Value"
            //placeholder={"Max RSSI"}
            disabled={enableSwitch ? false : true}
            name="maxrssi"
            value={maxRssi }
            onChange={(e) => onMaxRssiChange(e.target.value )}
          />
          {errors.current.includes("maxrssiErr") ? (<ErrorMsg>{t('validation.rules.lostDevice.maxrssiErrMsg')}</ErrorMsg>) : null}
          {errors.current.includes("maxrssiAlpaMsg") ? (<ErrorMsg>{t('validation.rules.lostDevice.maxrssiAlpaMsg')}</ErrorMsg>) : null}
          {errors.current.includes("maxrssiNegMsg") ? (<ErrorMsg>{t('validation.rules.lostDevice.maxrssiNegMsg')}</ErrorMsg>) : null}
          {errors.current.includes("maxrssi50Msg") ? (<ErrorMsg>{t('validation.rules.lostDevice.maxrssi50Msg')}</ErrorMsg>) : null}
        </FormGroup>
        <ButtonContainer style={{}}>
          <Button
            onClick={() => onClickResetBtn()}
            type="secondary"
            style={{ backgroundColor: '#757575', margin: '8px' }}
          >
            {t('lostDeviceNearbyNotifications.Reset to default')}
          </Button>
        </ButtonContainer>
        {anyOneChanged &&
          <ButtonContainer>
            <Button
              onClick={() => onClickCancelBtn()}
              type="primary"
              style={{ background: 'white', color: 'black', border: '2px solid gray' }}
            >
              {t('cancel')}
            </Button>
            <Button
              onClick={handleSaveChanges}
              type="primary"
              style={{}}
            >
              {t('save')}
            </Button>
          </ButtonContainer>
        }
        <BottomNavLinks />
    </>
  );
}